import { render, staticRenderFns } from "./SupplCertn.vue?vue&type=template&id=77738374"
import script from "./SupplCertn.vue?vue&type=script&lang=js"
export * from "./SupplCertn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77738374')) {
      api.createRecord('77738374', component.options)
    } else {
      api.reload('77738374', component.options)
    }
    module.hot.accept("./SupplCertn.vue?vue&type=template&id=77738374", function () {
      api.rerender('77738374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/SupplCertn.vue"
export default component.exports